/**
 * Title: Action Types for Product Parts
 * Description: Action Types for Product Parts
 * Author: Iqbal Hossain
 * Date: 09-January-2022
 * Modified: 09-January-2022
 **/

export const FETCH_PRODUCT_PARTS = 'FETCH_PRODUCT_PARTS';
export const TOGGLE_PRODUCT_PART_SIDEBAR = 'TOGGLE_PRODUCT_PART_SIDEBAR';
export const TOGGLE_PRODUCT_PART_STATUS = 'TOGGLE_PRODUCT_PART_STATUS';
export const FETCH_PRODUCT_PARTS_BY_QUERY = 'FETCH_PRODUCT_PARTS_BY_QUERY';
export const ADD_PRODUCT_PART = 'ADD_PRODUCT_PART';
export const DELETE_PRODUCT_PART = 'DELETE_PRODUCT_PART';
export const FETCH_PRODUCT_PART_BY_ID = 'FETCH_PRODUCT_PART_BY_ID';
export const UPDATE_PRODUCT_PART = 'UPDATE_PRODUCT_PART';
export const DELETE_PRODUCT_PART_BY_RANGE = 'DELETE_PRODUCT_PART_BY_RANGE';
